import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=697ec6d8&"
import script from "./LayoutMain.vue?vue&type=script&lang=ts&"
export * from "./LayoutMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports